import { differenceInCalendarDays } from "date-fns";
import { TFunction } from "i18next";
import * as Yup from "yup";

import { CourtHearingsFilterValues } from "@/pages/court-hearings/CourtHearings.types";

// Mirrors the backend's period guard (GetCourtHearingsQueryValidator).
const MAX_RANGE_IN_DAYS = 366;

export function courtHearingsFilterValidationSchema(t: TFunction): Yup.ObjectSchema<CourtHearingsFilterValues> {
  return Yup.object({
    from: Yup.date()
      .nullable()
      .required(
        t("common.validation.fieldRequired", { fieldName: t("courtHearings.filter.from") })
      ) as Yup.Schema<Date | null>,
    to: Yup.date()
      .nullable()
      .required(t("common.validation.fieldRequired", { fieldName: t("courtHearings.filter.to") }))
      .test("to-after-from", t("courtHearings.filter.validation.toBeforeFrom"), function (to) {
        const { from } = this.parent as Pick<CourtHearingsFilterValues, "from">;
        if (!from) {
          return true;
        }
        return to >= from;
      })
      .test("range-within-limit", t("courtHearings.filter.validation.rangeTooLong"), function (to) {
        const { from } = this.parent as Pick<CourtHearingsFilterValues, "from">;
        if (!from) {
          return true;
        }
        return differenceInCalendarDays(to, from) <= MAX_RANGE_IN_DAYS;
      }) as Yup.Schema<Date | null>,
    courtId: Yup.string().nullable() as Yup.Schema<string | null>,
    counselorId: Yup.string().nullable() as Yup.Schema<string | null>,
  });
}
